<template>
    <div>
        <el-page-header v-if="path !== '/game/index'" class="head-back" @back="goBack"></el-page-header>
        <div class="game-header" :style="{ backgroundImage: 'url(' + img + ')' }">
        </div>
    </div>
</template>
<script>
export default {
    name: 'game-header',
    data () {
        return {
            img: '',
            path: this.$route.path
        }
    },
    created () {
        if (this.$route.path === '/game/index') {
            localStorage.setItem('headImg', 'game-head-main')
        }
        this.img = require('@/assets/images/game/' + (localStorage.getItem('headImg') || 'game-head-main') + '.png')
    },
    methods: {
        goBack () {
            if (this.$route.path === '/game/index') return
            this.$router.push({ path: '/game/index' })
        }
    }
}
</script>
<style scoped>
.game-header {
    background-color: #f5f7fa;
    padding: 20px;
    border-radius: 4px;
    background-size: cover;
    background-position: center;
    height: 70px;
}

.head-back {
    color: #409EFF;
    background-color: #ffffff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/game/head.vue